import React from 'react';
import { View } from 'react-native';
import { useQuery, useMutation } from '@apollo/client';
import { useForm } from 'react-hook-form';

import Input from 'app/src/elements/inputs';
import { Button, ButtonGroup, ButtonContainer } from 'app/src/elements/buttons';
import { Text } from 'app/src/styles';

import { UPDATE_BUYER } from './queries';

const Review = ({ buyer, type, refetch, setShowModal }) => {
  const { control, handleSubmit, formState: { errors } } = useForm({
    defaultValues: {
      id: buyer.id,
      status: `${type}d`,
      reviewNotes: buyer.reviewNotes,
    }
  });

  const [updateBuyer] = useMutation(UPDATE_BUYER, {
    onCompleted: () => {
      refetch();
      setShowModal(false);
    }
  });

  const onSubmit = input => {
    updateBuyer({ variables: input });
  };

  return (
    <View>
      <Input.Text
        label="Notes:"
        name="reviewNotes"
        control={control}
        errors={errors}
        rules={{ required: true }}
        multiline
        rows={4}
      />
      <ButtonContainer>
        <ButtonGroup>
          <Button label={`${type} Buyer`} onPress={handleSubmit(onSubmit)} />
        </ButtonGroup>
      </ButtonContainer>
    </View>
  );
};

export default Review;
